import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavigationService } from 'src/app/services/navigation.service';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from '../sign-up-modal/sign-up-modal.component';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import Order from 'src/smoothr-web-app-core/models/Order';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-header-desktop',
	templateUrl: './header-desktop.component.html',
	styleUrl: './header-desktop.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderDesktopComponent {
	@Input() customer: Customer;
	@Input() venue: Venue;
	@Output() back = new EventEmitter();
	@Output() showPopover = new EventEmitter<any>();
	@Input() order: Order;
	@Input() showGoToBasketBtn = false;
	@Output() showBasket = new EventEmitter<void>();
	constructor(
		private navService: NavigationService,
		private modalCtrl: ModalController,
		private repository: RepositoryService
	) {}
	get price(): number {
		if (!this.order) {
			return 0;
		}
		if (this.order && this.order?.preorder?.type === PreorderType.FOOD_SPOT) {
			return OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null);
		} else {
			return OrderUtils.orderTotalPrice(this.order, true, true, null);
		}
	}
	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}
	onBack() {
		this.back.emit();
	}

	async login() {
		const result = await SignInModalComponent.show(this.modalCtrl);
		if (result === 'sign-up') {
			await SignUpModalComponent.show(this.modalCtrl);
		}
	}
	async signUp() {
		const result = await SignUpModalComponent.show(this.modalCtrl);
		console.log('RESULT', result);
	}
	showPopoverToBack($event: any) {
		this.showPopover.emit($event);
	}
}
